import React from 'react';
import { Link } from 'react-router-dom';
import './Breadcrumbs.css';

/**
 * Visible breadcrumb navigation.
 * Matches the SEO.breadcrumbSchema() data used in each page.
 *
 * Usage:
 *   <Breadcrumbs items={[{ name: 'Products', url: '/products' }, { name: 'Louvered Pergola' }]} />
 *
 * "Home" is always prepended automatically.
 * The last item (no url) is rendered as plain text (current page).
 */
function Breadcrumbs({ items = [] }) {
  const allItems = [{ name: 'Home', url: '/' }, ...items];

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol className="breadcrumbs__list">
        {allItems.map((item, i) => {
          const isLast = i === allItems.length - 1;
          return (
            <li className="breadcrumbs__item" key={i}>
              {!isLast && item.url ? (
                <>
                  <Link to={item.url} className="breadcrumbs__link">{item.name}</Link>
                  <span className="breadcrumbs__sep" aria-hidden="true">/</span>
                </>
              ) : (
                <span className="breadcrumbs__current" aria-current="page">{item.name}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
